import { Alerts } from 'constants/alerts';

import React, { useState } from 'react';

import { useApiContext } from 'context/apiContext';
import { CumulativeReportFilterValues } from 'pages/Finance/CumulativeReport/CumulativeReportFilter';
import { useListContext } from 'react-admin';
import { EmptyListAlert } from 'shared/mui/Alert/EmptyListAlert/EmptyListAlert';
import { FinanceUserAlert } from 'shared/mui/Alert/FinanceUserAlert/FinanceUserAlert';

import { CumulativeReportCollapsibleSkeleton } from '../CumulativeReportCollapsibleSkeleton';
import { CumulativeReportDatagrid } from './CumulativeReportDatagrid';
import { BoxStyled } from './CumulativeReportDatagrid.styled';
import { CumulativeReportDatagridPeriod } from './CumulativeReportDatagridPeriod';

export type Props = {
  filters: CumulativeReportFilterValues;
  isLoading: boolean;
  toggleDrawer: (open: boolean) => () => void;
};

export const CumulativeReportDatagridCollapsible: React.FC<Props> = ({
  filters,
  isLoading,
  toggleDrawer,
}) => {
  const { data: cumulativeReport = [] } = useListContext();
  const [isOpen, setIsOpen] = useState(true);
  const { user } = useApiContext();
  if (isLoading) {
    return <CumulativeReportCollapsibleSkeleton columnsCount={14} />;
  }

  if (user.alerts.includes(Alerts.EmptyProviderAccountAccess)) {
    return <FinanceUserAlert firstName={user.firstName} lastName={user.lastName} />;
  }

  if (!cumulativeReport.length && !Object.keys(filters).length) {
    return <EmptyListAlert onClick={toggleDrawer(true)} />;
  }

  const toggleIsOpen = () => {
    setIsOpen((prev) => !prev);
  };

  if (isOpen) {
    return (
      <BoxStyled>
        {filters?.periodTo && filters?.periodFrom && (
          <CumulativeReportDatagridPeriod
            filters={filters}
            isOpen={isOpen}
            toggleIsOpen={toggleIsOpen}
          />
        )}
        <CumulativeReportDatagrid filters={filters} />
      </BoxStyled>
    );
  }

  return (
    <BoxStyled>
      <CumulativeReportDatagridPeriod
        filters={filters}
        isOpen={isOpen}
        toggleIsOpen={toggleIsOpen}
      />
    </BoxStyled>
  );
};
